<template>
    <div class="listmain ">
        <h1 class="firTitle">小微登录接入</h1>
        <h3 class="sedTitle">说明</h3>

        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
      需要传入accessToken和clientId才可以接入小微（腾讯相关服务：微信、QQ等）
          </span>
        </p>
        <highlight-code lang="javascript" v-html="">
           <span>
  PlantFormProxy proxy = PlantFormProxy.getInstance();
 proxy.setPlantForm(new QQMusic());

 proxy.bindLogin(MainActivity.this,
  QQMusicLoginBean.newBuilder()
    .accessToken("").clientId("").build(),
  new ResponseCallBackListener&lt;QQMusicLoginResponse&gt;() {
             @Override
             public void onSuccess(QQMusicLoginResponse platformLoginResponseBean) {
                 Toast.makeText(MainActivity.this, "登录成功", Toast.LENGTH_SHORT).show();
             }

             @Override
             public void onError(String errorCode, String error) {
                 Toast.makeText(MainActivity.this, error, Toast.LENGTH_SHORT).show();
             }
 });
       </span>
        </highlight-code>
    </div>
</template>

<script>
    export default {
        name: ""
    };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    h1,
    h2,
    h3,
    h4,
    h5 {
        padding: 0;
        margin: 0px;
        font-weight: normal;
    }

    ul,
    li {
        list-style: none;
    }

    .listmain {
        font-size: 14px;
        line-height: 26px;
        .firTitle {
            font-size: 20px;
            color: #1e4d79;
            margin-bottom: 30px;
        }
        .sedTitle {
            font-size: 16px;
            font-weight: bold;
            padding-bottom: 10px;
            border-bottom: 1px solid #f3f3f3;
            margin-bottom: 15px;
            margin-top: 50px;
            &.fir {
                margin-top: 0px;
            }
        }
        .thirdTitle {
            margin-top: 50px;
            font-weight: bold;
            line-height: 30px;
            font-size: 16px;
        }
        .codeTitle {
            font-weight: bold;
            line-height: 26px;
        }
        pre {
            margin-top: 20px;
        }
        img {
            margin: 30px 0;
            width: 100%;
        }
        table,
        table tr th,
        table tr td {
            border: 1px solid #000;
            text-align: center;
        }
        table {
            line-height: 30px;
            width: 100%;
            border-collapse: collapse;
        }
    }

    .el-submenu .el-menu-item {
        min-width: 190px;
        background: #f5f5f5;
    }

    .el-submenu {
        min-width: 190px;
        background: #f5f5f5;
    }

    img {
        margin-top: 30px;
        margin-bottom: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/tutor/SDK-android/X_w.vue